export default "__VITE_ASSET__DRBd1lkJ__"